import React from "react";

import { BlockTitle } from "../../Component";
import VacancyFieldBlock from "./VacancyFieldBlock";

// { title, <listKey> } shaklidagi bo'lim: sarlavha va qatorlar alohida
// tahrirlanadi, har birining o'z tugmasi bor.
const VacancySectionBlock = ({
  sectionTitle,
  field,
  listKey,
  listLabel,
  addButtonTitle,
}) => (
  <div className="mt-4">
    <BlockTitle tag="h5" className="mb-3">
      {sectionTitle}
    </BlockTitle>

    <VacancyFieldBlock
      label="Title"
      getInitial={(normalized) => normalized[field].title}
      getSaved={(vacancy) => vacancy?.[field]?.title}
      buildPatch={(value, normalized) => ({
        [field]: { ...normalized[field], title: value },
      })}
    />

    <VacancyFieldBlock
      label={listLabel}
      isList
      addButtonTitle={addButtonTitle}
      getInitial={(normalized) => normalized[field][listKey]}
      getSaved={(vacancy) => vacancy?.[field]?.[listKey]}
      buildPatch={(value, normalized) => ({
        [field]: { ...normalized[field], [listKey]: value },
      })}
    />
  </div>
);

export default VacancySectionBlock;
